import { render, staticRenderFns } from "./addExam.vue?vue&type=template&id=2215c292&scoped=true&"
import script from "./addExam.vue?vue&type=script&lang=js&"
export * from "./addExam.vue?vue&type=script&lang=js&"
import style0 from "./addExam.vue?vue&type=style&index=0&id=2215c292&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2215c292",
  null
  
)

export default component.exports